

import Badge from 'vux/src/components/badge/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'

import { mapActions, mapGetters } from 'vuex'
import Cookies from 'js-cookie'

import { QINIU_SERVER } from '../../config'
import meiqia from '../../utils/meiqia'

import iconTourOrder from 'assets/icons/icon-tour-order@3x.png'
import iconBuyOrder from 'assets/icons/icon-buy-order@3x.png'
import iconCtcOrderSell from 'assets/icons/icon-ctc-sell@3x.png'
import iconCoupon from 'assets/icons/icon-coupon@3x.png'
import iconWallet from 'assets/icons/icon-wallet@3x.png'
import iconQuestion from 'assets/icons/icon-bubble@3x.png'
import iconFavour from 'assets/icons/icon-favour2@3x.png'
import iconAddr from 'assets/icons/icon-location@3x.png'
import iconHelp from 'assets/icons/icon-help@3x.png'
import iconLogo from 'assets/icons/icon-logo@3x.png'
import iconAttn from 'assets/icons/icon-attn@3x.png'
import iconCustomerService from 'assets/icons/icon_kefu3@3x.png'
import iconKefu from 'assets/icons/icon-kefu-online@3x.png'
import defaultAvatarImg from 'assets/default-avatar@3x.png'
import bannerImg from 'assets/banner-download@3x.png'

import { isWeixinBrowser } from '../../utils'

export default {
name: 'User',
components: {
Cell,
Group,
Badge,
},
methods: {
...mapActions(['fetchUserInfo', 'showToast']),





chat() {
this.MEIQIA('showPanel')
},
loadSellerAuth() {
const req = {
userId: this.$jwt.userId,
}

this.$http.post('/api/user/sellerAuth', req)
.then((data) => {
this.c2cSellerAuth = data
})
},
toUserInfo() {
this.$router.push({ name: 'user-info' })
},
getMineStatistics() {
const req = {
userId: this.$jwt.userId,
}
this.$http.post('/api/user/statistics', req)
.then(res => res.json())
.then((data) => {
this.mineStatistics = data
})
.catch((err) => {
this.showToast({
content: err.body.resultInfo,
})
})
},
},
computed: {
...mapGetters({
user: 'getUser',
}),
isWeixinBrowser() {
return isWeixinBrowser()
},
c2cSellerCount() {
if (this.mineStatistics && this.mineStatistics.c2cSellerCount) {
return this.mineStatistics.c2cSellerCount
}
return ''
},
userAvatar() {
if (this.user && this.user.avatar) {
return QINIU_SERVER + this.user.avatar
}
return defaultAvatarImg
},

questionTitle() {
/* eslint-disable no-extra-boolean-cast */
const title = '我的提问'
const questionCount = this.user.questionCount
if (!!questionCount) {
return `${title}  (${questionCount})`
}
return title
},
favTitle() {
/* eslint-disable no-extra-boolean-cast */
const title = '我的收藏'
const favCount = this.user.favCount
if (!!favCount) {
return `${title}  (${favCount})`
}
return title
},
MEIQIA() {
/* eslint-disable no-underscore-dangle*/
return window._MEIQIA
},
},
data() {
return {
iconBuyOrder,
iconTourOrder,
iconCtcOrderSell,
iconCoupon,
iconWallet,
iconAddr,
iconQuestion,
iconFavour,
iconHelp,
iconLogo,
iconAttn,
iconCustomerService,
iconKefu,
bannerImg,
mineStatistics: null,
c2cSellerAuth: null,
}
},
created() {
meiqia.init()
document.title = '我的'
const { userId } = this.$jwt
Cookies.remove('logout')

if (!(this.user && this.user.id === userId)) {
this.fetchUserInfo(userId)
.catch(err => this.showToast({ content: err.body.resultInfo }))
}
this.loadSellerAuth()
this.getMineStatistics()
},
}



// WEBPACK FOOTER //
// ./client/components/User/User.vue